import datepicker from 'angular-ui-bootstrap/src/datepicker'
import modal from 'angular-ui-bootstrap/src/modal'

angular.module('utils', ['config', 'ngAnimate', datepicker, modal])

/*** Add utility functions to Lodash: ***/

if (!_) {
	throw 'Lodash is not loaded! This module is required!'
}

// _.humanizedJoin(array, separator, beforeLast, afterFirst)
// Warn if overriding existing method:
if (_.has(_, 'humanizedJoin')) {
	console.warn(
		"Overriding existing _.humanizedJoin. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."
	)
}
// Attach the method to Lodash:
_.humanizedJoin = function (array, separator, beforeLast, afterFirst) {
	if (arguments.length < 2) return _.flattenDeep(array).join(separator) //return standard Array.join result
	beforeLast = beforeLast || separator
	afterFirst = afterFirst || separator

	return _.flattenDeep(array).reduce(function (acc, elem, index, array) {
		var sep = separator
		if (index == 1) sep = afterFirst
		if (index == array.length - 1) sep = beforeLast
		if (index == 0) sep = ''
		return acc + sep + elem
	}, '')
}
